import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";

import useAddOfficeBrand from "./hooks/useAddOfficeBrand";
import useOfficeBrand from "./hooks/useOfficeBrand";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import SelectInput from "../../../../components/SelectInput";
import { addStateOfficeBrand, setFilterTextOfficeBrand } from "./atoms/atoms";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useQuery } from "react-query";
import { getStates } from "../../../../actions/Utilities/Common";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import { useQueryClient } from "react-query";

const OfficeBrandForm = () => {
  //Hooks
  const { mutateAsync: AddOfficeBrand } = useAddOfficeBrand();
  const { data } = useOfficeBrand();
  //Recoils Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateOfficeBrand);
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasOfficeBrand, setHasOfficeBrand] = useState(false);
  const userAccount = useRecoilState(accountAtom);
  const [states, setStates] = useState([]);
  const queryClient = useQueryClient();

  useQuery("States", getStates, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setStates(
        res.map((data) => {
          return { label: data.state, value: data.stateId };
        })
      );
    },
  });

  const defaulValues = {
    status: null,
    createdOn: null,
    createdBy: "",
    state: "",
    brandDescription: "",
    brandMarketingName: "",
    brandName: "",
    usedInMexicp: false,
  };
  const [emptypeNewData, setNewData] = useState([defaulValues]);

  const handleAddOfficeBrand = (SourceType, fieldName, inputvalue) => {
    inputvalue = inputvalue.trim();
    if (SourceType === "AddOfficeBrand") {
      emptypeNewData.map((x) => (x[fieldName] = inputvalue));
      emptypeNewData.map((x) => (x.createdBy = userAccount[0].userName));
      emptypeNewData.map((x) => (x.status = 1));

      const result = data.filter(
        (item) =>
          item.brandName.toUpperCase() ===
            emptypeNewData[0].brandName.toUpperCase() &&
          item.brandMarketingName.toUpperCase() ===
            emptypeNewData[0].brandMarketingName.toUpperCase() &&
          item.state.toUpperCase() === emptypeNewData[0].state.toUpperCase()
      );

      if (result.length > 0 && result !== undefined) {
        setHasOfficeBrand(true);
        setChanged(false);
      } else {
        setHasOfficeBrand(false);
        let reqFields = ["brandName", "brandMarketingName", "state"];
        if (
          reqFields.includes(fieldName) &&
          emptypeNewData[0].brandName &&
          emptypeNewData[0].brandMarketingName &&
          emptypeNewData[0].state &&
          inputvalue !== ""
        ) {
          setChanged(true);
        } else if (
          fieldName === "brandDescription" &&
          emptypeNewData[0].brandName &&
          emptypeNewData[0].brandMarketingName &&
          emptypeNewData[0].state
        ) {
          setChanged(true);
        } else {
          setChanged(false);
        }
      }
    }
  };

  //save changes
  const handleSave = (emptypeNewData) => {
    if (actionAddState) {
      AddOfficeBrand(emptypeNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModal(false);
          } else {
            setActionAddState(false);
            setNewData([defaulValues]);
            queryClient.invalidateQueries(["GetOfficeBrands"]);
            toast.fire("Success", "Office Brand Added Successfully", "success");
            setOpenModal(false);
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Add Office Brand", "error");
          queryClient.invalidateQueries(["GetOfficeBrands"]);
          setOpenModal(false);
        },
      });
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Brand Name",
      field: "BrandName",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <div className="">
              <TextInput
                required={true}
                defaultValue={rowData.status}
                onChange={(e) =>
                  handleAddOfficeBrand(
                    "AddOfficeBrand",
                    "brandName",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Brand Description",
      field: "BrandDescription",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <div className="">
              <TextInput
                defaultValue={rowData.brandDescription}
                onChange={(e) =>
                  handleAddOfficeBrand(
                    "AddOfficeBrand",
                    "brandDescription",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Brand Marketing Name",
      field: "BrandMarketingName",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <div className="">
              <TextInput
                defaultValue={rowData.brandMarketingName}
                onChange={(e) =>
                  handleAddOfficeBrand(
                    "AddOfficeBrand",
                    "brandMarketingName",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "State",
      field: "State",
      render: (rowData) => {
        return (
          <div className="w-full">
            <div className="">
              <SelectInput
                options={states}
                placeholder="state"
                defaultValue={
                  states.filter((x) => x.label === rowData.state)[0]
                }
                onChange={(selectedOptions) => {
                  handleAddOfficeBrand(
                    "AddOfficeBrand",
                    "state",
                    selectedOptions === null ? "" : selectedOptions.label
                  );
                }}
              />
              {/* <TextInput
                defaultValue={rowData.state}
                onChange={(e) =>
                  handleAddOfficeBrand(
                    "AddOfficeBrand",
                    "State",
                    e.target.value
                  )
                }
              /> */}
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="animate-fade-in-down">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Office Brand"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(emptypeNewData);
          }}
        />
        <div className="p-3  space-y-1 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold ">
              Add New Office Brand
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-left shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!changed ? "opacity-50" : "opactiy-100"}`}
                disabled={!changed}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClick={() => {
                  setActionAddState(!actionAddState);
                }}
              />
            </div>
          </div>

          <div className="mt-2 h-0.5 w-full border-b-2 border-secondary mb-5 "></div>

          <div className="py-1"></div>

          <div className="space-y-5 space-x-2 space-y-20 w-full  ">
            <MaterialExTable
              columns={matcolumns}
              data={emptypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="pb-1.5">
            <div className="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeBrandForm;
